/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentBreakdown } from './InvestmentBreakdown';
import {
    InvestmentBreakdownFromJSON,
    InvestmentBreakdownFromJSONTyped,
    InvestmentBreakdownToJSON,
} from './InvestmentBreakdown';

/**
 * 
 * @export
 * @interface Beneficiary
 */
export interface Beneficiary {
    /**
     * 
     * @type {string}
     * @memberof Beneficiary
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Beneficiary
     */
    lastName: string;
    /**
     * 
     * @type {Array<InvestmentBreakdown>}
     * @memberof Beneficiary
     */
    investmentBreakdown: Array<InvestmentBreakdown>;
}

/**
 * Check if a given object implements the Beneficiary interface.
 */
export function instanceOfBeneficiary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "investmentBreakdown" in value;

    return isInstance;
}

export function BeneficiaryFromJSON(json: any): Beneficiary {
    return BeneficiaryFromJSONTyped(json, false);
}

export function BeneficiaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Beneficiary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['FirstName'],
        'lastName': json['LastName'],
        'investmentBreakdown': ((json['InvestmentBreakdown'] as Array<any>).map(InvestmentBreakdownFromJSON)),
    };
}

export function BeneficiaryToJSON(value?: Beneficiary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstName': value.firstName,
        'LastName': value.lastName,
        'InvestmentBreakdown': ((value.investmentBreakdown as Array<any>).map(InvestmentBreakdownToJSON)),
    };
}

